import { FormPanel } from "../../../../modules/content/components/FormPanel/FormPanel";
import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  errorMessage,
  eyebrow,
  fields,
  heading,
  parentClass,
  spacing,
  submitLabel,
  successMessage,
}: IFormBlockProps) => {
  if (!fields?.length || !submitLabel || !successMessage || !errorMessage) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);
  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-6">
        {hasIntro ? (
          <RavioliCommonContent
            alignment={alignment}
            buttons={buttons}
            className="self-start border border-primary bg-collection p-6 lg:col-span-4 lg:p-8"
            description={description}
            eyebrow={eyebrow}
            heading={heading}
          />
        ) : null}
        <div
          className={
            hasIntro
              ? "border border-primary bg-surface p-6 lg:col-span-8 lg:col-start-5 lg:p-10"
              : "border border-primary bg-surface p-6 lg:col-span-8 lg:p-10"
          }
        >
          <FormPanel
            errorMessage={errorMessage}
            fields={fields}
            submitLabel={submitLabel}
            successMessage={successMessage}
          />
        </div>
      </div>
    </RavioliSection>
  );
};

FormBlock.displayName = "Block::FormBlock";
